import { render, staticRenderFns } from "./CheckBeforePack.vue?vue&type=template&id=8c464936&scoped=true&"
import script from "./CheckBeforePack.vue?vue&type=script&lang=js&"
export * from "./CheckBeforePack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c464936",
  null
  
)

export default component.exports